import ActionDropdown from "../../ActionDropdown";
import TableCheck from "../TableCheck";
import { dateFine } from "../../../util/Utilities";
import DateFormatter from "../../DateFormatter";
import { Dropdown } from "react-bootstrap";

const CategoriesColumns = [
    {
        Label: TableCheck,
        Component: TableCheck

    },
    {
        Label: () => 'id',
        accessor: 'id'
    },
    {
        Label: () => 'Nombre',
        accessor: 'name'
    },
    {
        Label: () => 'Categoría Padre',
        Component: ({ parentCategory }) => parentCategory?.name ? parentCategory?.name : 'No tiene.'
    },
    {
        Label: () => 'Path',
        Component: ({ value }) => value?.path || '--'
    },
    {
        Label: () => 'Responsables',
        Component: ({ value }) => <Dropdown>
            <Dropdown.Toggle variant="primary" size="sm" id="dropdown-basic">
                Responsables ({value?.users?.length})
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {
                    value?.users?.length > 0 ?
                        value?.users?.map((user, i) => {
                            return (
                                <Dropdown.Item>
                                    <div className="d-flex gap-2 align-items-center">
                                        <img src={user?.imagePath} width={40} height={40} className="rounded-circle" />
                                        <b className="text-black">{user?.name}</b>
                                    </div>
                                </Dropdown.Item>
                            )
                        })
                        :
                        <Dropdown.Item>
                            <div className="text-center">
                                Sin responsables
                            </div>
                        </Dropdown.Item>
                }
            </Dropdown.Menu>
        </Dropdown>
    },
    {
        Label: () => 'Fecha de Creación',
        Component: ({ value }) => <DateFormatter value={dateFine(value?.createdAt)} dateFormat="dd/MM/yyyy hh:mm:ss" />
    },
    {
        Label: () => 'Acciones',
        Component: ActionDropdown
    }
];

export default CategoriesColumns;

